import { z } from 'zod';

const zodDateTimeSchema = z.iso.datetime({ offset: true });

export const zodInvoiceEmailOrderBySchema = z.enum([
  'received_at',
  'sender',
  'subject',
]);

export const zodInvoiceEmailListQueryParamsSchema = z.object({
  companyIds: z.array(z.uuid()).optional(),
  limit: z.number().int().min(1).max(500).prefault(50),
  offset: z.number().int().min(0).prefault(0),
  orderBy: zodInvoiceEmailOrderBySchema.prefault('received_at'),
  receivedFrom: zodDateTimeSchema.optional(),
  receivedUntil: zodDateTimeSchema.optional(),
  searchString: z.string().trim().min(1).max(500).optional(),
  sortOrder: z.enum(['ASC', 'DESC']).prefault('DESC'),
});

const zodInvoiceEmailListItemSchema = z.object({
  attachmentCount: z.number().int().nonnegative(),
  attachmentNames: z.array(z.string()),
  companyId: z.uuid(),
  companyName: z.string().nullable(),
  id: z.string(),
  receivedAt: zodDateTimeSchema.nullable(),
  recipients: z.array(z.string()),
  sender: z.string().nullable(),
  subject: z.string().nullable(),
});

export const zodInvoiceEmailListResponseSchema = z.object({
  data: z.array(zodInvoiceEmailListItemSchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number().int().nonnegative(),
  totalCount: z.number().int().nonnegative().nullable(),
});

const zodInvoiceEmailAttachmentSchema = z.object({
  contentType: z.string(),
  filename: z.string(),
  id: z.uuid(),
  sizeBytes: z.number().int().nonnegative(),
});

export const zodInvoiceEmailDetailResponseSchema =
  zodInvoiceEmailListItemSchema.extend({
    attachments: z.array(zodInvoiceEmailAttachmentSchema),
    bodyHtml: z.string().nullable(),
    bodyText: z.string().nullable(),
  });
